module.exports = __webpack_public_path__ + "ea7e4090370e82b6a1ef029245e90bf3.svg";